import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { HashLink as Link } from "react-router-hash-link";
import { Ii18nInterpolationObject } from "src/@types/i18next";

interface Props {
  onItemClick?: (id: string) => void;
  activeLink: string;
  subtitle: Ii18nInterpolationObject;
  id: string;
}

export const HowItWorksSidebarSubtitle: FC<Props> = ({
  id,
  subtitle,
  onItemClick,
  activeLink,
}) => {
  const { t } = useTranslation();

  const onClick = () => onItemClick(id);

  return (
    <div
      className={cn("px-5 py-3 w-full", {
        "bg-purple-lighter rounded-20": activeLink === id,
      })}
      onClick={onClick}
    >
      <Link to={`#${id}`} smooth>
        <span className="text-purple-base text-lg font-medium">
          {t(subtitle.i18nKey)}
        </span>
      </Link>
    </div>
  );
};
